import { without } from 'ramda';

// remove false values from array and check if there is anything left
const nonEmptyData = (items: Array<boolean>): boolean => without([false], items).length > 0;

export default nonEmptyData;
